import React from 'react';
import Relay from 'react-relay';
import RelayStore from '../../RelayStore';

import SportunityPanel from '../../components/SportunityPanel';
import UpdateSportunityMutation from '../../mutations/Sportunity/UpdateSportunityMutation';

class EditSportunity extends React.Component {

	state = {
		edit: false,
	}

	onUpdateSportunity(sportunity, callback) {
		const { viewer } = this.props ;

		let mutation = new UpdateSportunityMutation({sportunity, viewer, notify_people: false, modifyRepeatedSportunities: true });

	  	RelayStore.commitUpdate( mutation, {
			onFailure: (error) => {
				console.log('error', error.getError());
				alert('Update Failed');
			},
			onSuccess: (response) => {
				console.log('success', response);
				alert('Update Success');

				if (typeof callback !== 'undefined') 
					callback()
			}
	  	});

	}

	onUpdateSerie = (sportunity) =>
		this.onUpdate(sportunity, true)

	onUpdate = (sportunity, modifySerie=false) => {
		const { viewer } = this.props ;

		let mutation = new UpdateSportunityMutation({
			sportunity: {
				id: this.props.relay.variables.sportunityId,
				...sportunity,
			},
			modifyRepeatedSportunities: modifySerie,
			viewer,
			notify_people: false,
		});

  	RelayStore.commitUpdate( mutation, {
			onFailure: (error) => {
				console.log('error', error.getError());
				alert('Update Failed');
			},
			onSuccess: (response) => {
				console.log('success', response);
				alert('Update Success');
			}
  	});

	}

	componentWillMount() {
		this.props.relay.setVariables({
			sportunityId: this.props.params.id,
			sportunityFetch: true,
		})
		this.setState({
			edit: this.props.location.state.edit,
		})
	}

    render() {
	    return (
			<div className="panel" style={{marginTop:20}}>
				{this.props.relay.variables.sportunityId &&
					<SportunityPanel
						viewer={this.props.viewer}
						isEditing={this.state.edit}
						onUpdateSportunity={this.onUpdateSportunity.bind(this)}
						onUpdate={this.onUpdate}
						onUpdateSerie={this.onUpdateSerie}
						{...this.props.relay.variables}
				  	/>
				}
			</div>
	    );
  	}
}

EditSportunity.propTypes = ({
  viewer: React.PropTypes.object.isRequired,
  relay: React.PropTypes.object.isRequired,
  children: React.PropTypes.node,
});


export default Relay.createContainer(EditSportunity, {
	initialVariables: {
		sportunityId: null,
		sportunityFetch: false,
	},
  fragments: {
    viewer: (variables) => Relay.QL`
      fragment on Viewer {
				id
        ${UpdateSportunityMutation.getFragment('viewer')}
        ${SportunityPanel.getFragment('viewer', variables)}
      }
    `,
  }
});



// WEBPACK FOOTER //
// ./src/pages/Sportunity/EditSportunity.js